/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { EqualKeyTypeValue } from './EqualKeyTypeValue';

export const EqualKeyType: core.serialization.ObjectSchema<serializers.EqualKeyType.Raw, Truvity.EqualKeyType> =
    core.serialization.object({
        value: EqualKeyTypeValue,
    });

export declare namespace EqualKeyType {
    export interface Raw {
        value: EqualKeyTypeValue.Raw;
    }
}
